import _ from "lodash";
import nextButton from "./nextButton";
import questionTitle from "./questionTitle";

export default {
  props: ["question"],

  data() {
    return {
      loading: false,
      choice: null,
      hasAnswer: true
    };
  },

  components: {
    nextButton,
    questionTitle
  },

  computed: {
    answer() {
      return this.$store.getters["interview/getAnswer"](this.question.id);
    }
  },

  mounted() {
    if (this.answer) {
      this.choice = _.clone(this.answer);
    } else if (!this.question.fields || !this.question.fields.length) {
      this.choice = "";
    } else if (this.question.kind == "instruction") {
      this.choice = {};
    } else {
      this.choice = [];
    }
    if (
      !this.$props.question.required ||
      (this.$props.question.required && this.answer)
    ) {
      this.$store.dispatch("interview/setNext", true);
    }
  }
};
